import { DashboardPage } from "templates";

export const Dashboard = () => {

  document.title = "Dashboard | ADMIN PGK";

  return (
    <>
      <DashboardPage/>
    </>
  );
};

export default Dashboard;
